<div
  style="overflow-y: auto"
  mdbModal
  #createNewTradeModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="createNewTradeModal"
  aria-hidden="true"
  (close)="onClosed($event)"
>
  <div class="modal-dialog modal-fluid" role="document" *ngIf="showModal">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="showHideModal(false)">
          <span aria-hidden="true">×</span>
        </button>
        <div>
          <h4 class="modal-title w-100" id="modalHeading">Create New Trade</h4>
          <h5>{{ this.user.fullName }}</h5>
        </div>
      </div>
      <div class="modal-body">
        <form class="md-form mt-0" [formGroup]="newTradeForm" [hidden]="success" (ngSubmit)="submitHandler()">
          <div class="card-group">
            <div class="col-7">
              <div class="card h-100">
                <div class="card-header">Available Pins</div>
                <div class="card-body">
                  <div class="row row-cols-3">
                    <div class="col p-3" formArrayName="pins" *ngFor="let control of pins.controls; let i = index">
                      <div class="card" [formGroupName]="i">
                        <div class="card-header">
                          <div class="font-weight-bold">Pin: {{ control.value.pin }}</div>
                          <div class="text-muted small">Expiry: {{ control.value.pinExpiryDate | date: "MMM dd, yyyy" }}</div>
                        </div>
                        <div class="card-body">
                          <div>
                            <div class="font-weight-bold">
                              Avail: {{ control.value.pinBalance | currency: "ZAR" : "symbol-narrow" : "1.0-0" }}
                            </div>
                            <div class="text-muted small">
                              Of: {{ control.value.pinAmount | currency: "ZAR" : "symbol-narrow" : "1.0-0" }}
                            </div>

                            <div class="col">
                              <input
                                mdbInput
                                mdbValidate
                                [id]="generateId(i)"
                                formControlName="transactionUsedAmount"
                                type="number"
                                class="form-control"
                                (blur)="createPinsToUseListAndFiaAmountTotal(this.newTradeForm.value)"
                              />
                              <label for="{{ generateId(i) }}">Amount to use</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <small class="text-muted">Last updated 3 mins ago</small>
                </div>
              </div>
            </div>
            <div class="col-5">
              <div class="card panels-card h-100">
                <div class="card-header">Final Trade</div>

                <div class="card-body">
                  <div class="row" *ngIf="newTradeForm.errors?.['atLeastOneNumber'] && (newTradeForm.touched || newTradeForm.dirty)">
                    <div class="col pb-3">
                      <div class="card alert alert-danger">
                        <div class="card-body">You need at least one FIA amount and/or an SDA amount</div>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-12 d-flex">
                      <div class="col-6">
                        <input
                          mdbInput
                          mdbValidate
                          id="sdaAmount"
                          formControlName="sdaAmount"
                          type="number"
                          class="form-control"
                          (blur)="calculateTradeAmount()"
                        />
                        <label for="sdaAmount">SDA Amount</label>
                        <mdb-error *ngIf="isInvalidInput(sdaAmount)">SDA Amount error</mdb-error>
                      </div>
                      <div class="col-6">
                        <input mdbInput mdbValidate id="pipsAmount" formControlName="pipsAmount" type="number" class="form-control" />
                        <label for="pipsAmount">Pips Amount</label>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <div class="col-12 d-flex">
                      <div class="col-6">
                        <select mdbInput id="billingType" formControlName="billingType" class="form-control browser-default styled-select">
                          <option *ngFor="let billingType of billingTypes" [ngValue]="billingType.Id">
                            {{ billingType.Name }}
                          </option>
                        </select>
                        <label for="billingType">Select Billing Type</label>
                        <mdb-error *ngIf="isInvalidInput(billingType)">Billing Type error</mdb-error>
                      </div>
                      <div class="col-6">
                        <select
                          mdbInput
                          id="transactionStatus"
                          formControlName="transactionStatus"
                          class="form-control browser-default styled-select"
                        >
                          <option *ngFor="let status of statusList" [ngValue]="status.value" [disabled]="status.disabled">
                            {{ status.label }}
                          </option>
                        </select>
                        <label for="transactionStatus">Select Transaction Status</label>
                        <mdb-error *ngIf="isInvalidInput(transactionStatus)">Transaction Status error</mdb-error>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 d-flex">
                      <div class="col">
                        <div class="d-flex justify-content-between">
                          <span>
                            <input
                              mdbInput
                              mdbValidate
                              id="transactionDate"
                              formControlName="transactionDate"
                              class="form-control"
                              type="text"
                              style="height: 1.5rem"
                              onfocus="(this.type='date')"
                              onblur="(this.type='text')"
                            />
                            <label for="transactionDate">Date</label>
                            <mdb-error *ngIf="isInvalidInput(transactionDate)">Date Error</mdb-error>
                          </span>
                          <span class="col-3">
                            <input
                              mdbInput
                              mdbValidate
                              id="timeHrs"
                              formControlName="timeHrs"
                              type="number"
                              class="form-control"
                              min="0"
                              max="24"
                            />
                            <label for="timeHrs">Hrs</label>
                            <mdb-error *ngIf="isInvalidInput(timeHrs)">Hrs Error</mdb-error>
                          </span>
                          <span class="col-1"><label>:</label></span>
                          <span class="col-3">
                            <input
                              mdbInput
                              mdbValidate
                              id="timeMins"
                              formControlName="timeMins"
                              type="number"
                              class="form-control"
                              min="0"
                              max="60"
                            />
                            <label for="timeMins">Mins</label>
                            <mdb-error *ngIf="isInvalidInput(timeMins)">Mins Error</mdb-error>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col p-3">
                      <div class="card" style="background-color: #e0e0e0">
                        <div class="card-body pb-0">
                          <div class="d-flex justify-content-between">
                            <p class="font-weight-bold mb-0">Trade Date</p>
                            <p class="mb-0">{{ buildDateString() }}</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <p class="font-weight-bold mb-1">Pips</p>
                            <p class="mb-0">{{ pipsAmount.value }}</p>
                          </div>
                        </div>
                        <hr />
                        <div class="card-body pt-0">
                          <div class="d-flex justify-content-between">
                            <p class="font-weight-bold mb-1">Billing Type</p>
                            <p class="mb-0">{{ GetBillingTypeName(billingType.value) }}</p>
                          </div>
                          <div class="d-flex justify-content-between">
                            <p class="font-weight-bold mb-1">Initial Status</p>
                            <p class="mb-0">{{ GetTransactionStatusName(transactionStatus.value) }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="card" style="background-color: #ffcc80">
                        <div class="card-body pb-0">
                          <div *ngFor="let pin of pinsToUse" class="d-flex small justify-content-between">
                            <p class="mb-0">{{ pin.pin }}</p>
                            <p class="mb-0">{{ pin.transactionUsedAmount | currency: "ZAR" : "symbol-narrow" : "1.0-0" }}</p>
                          </div>
                          <div class="d-flex small justify-content-between">
                            <p class="font-weight-bold mb-0">FIA Total:</p>
                            <p class="font-weight-bold mb-0">{{ fiaAmount | currency: "ZAR" : "symbol-narrow" : "1.0-0" }}</p>
                          </div>
                          <hr />
                          <div class="d-flex small justify-content-between">
                            <p class="font-weight-bold mb-0">SDA Total:</p>
                            <p class="font-weight-bold mb-0">{{ sdaAmount.value | currency: "ZAR" : "symbol-narrow" : "1.0-0" }}</p>
                          </div>
                        </div>
                        <hr />
                        <div class="card-body pt-0">
                          <div class="d-flex justify-content-between">
                            <p class="font-weight-bold mb-1">Trade Amount</p>
                            <p class="font-weight-bold mb-0">{{ tradeAmount | currency: "ZAR" : "symbol-narrow" : "1.0-0" }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <div class="col-12 d-flex" style="justify-content: right">
                    <button type="submit" mdbBtn color="trakly-action" class="relative waves-light" [disabled]="newTradeForm.invalid">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div class="alert alert-info" role="alert" *ngIf="success">
          <div class="row text-center">
            <div class="col-3"></div>
            <div class="col-6">
              <div class="text-center font-weight-bold">Transaction successfully submitted!</div>
            </div>
            <div class="col-3"></div>
          </div>
          <div class="row text-center" *ngIf="success">
            <div class="col-3"></div>
            <div class="col-6">
              <button type="button" mdbBtn color="trakly-action" class="relative waves-light">Clear</button>
            </div>
            <div class="col-3"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<error-component [error]="errorResponse" [(showModal)]="showError"></error-component>
